import { useEffect, useRef, useState } from 'react';
import usePageVisibility from 'hooks/usePageVisibility';

const defaultOptions = {
    interval: 30 * 1000, // 30 seconds,
};

// Call useAPIData with interval
export default function useInterval([fetch, res, ...rest], _options = {}) {
    const options = { ...defaultOptions, ..._options };

    const [init, setInit] = useState(false);
    const [fetchProps, setFetchProps] = useState({ page: undefined, params: undefined });
    const timer = useRef(null);

    // start function
    const start = (page, params) => {
        setInit(true);
        setFetchProps({ page, params });

        // init fetch
        fetch(page, params);
    };

    const startTimer = () => {
        // cancel previous timer
        timer.current && clearInterval(timer.current);

        // start new timer
        timer.current = setInterval(() => {
            fetch(fetchProps.page, fetchProps.params);
        }, options.interval);
    };

    // watch `fetchProps` to start interval
    useEffect(() => {
        if (!init) return;

        startTimer();

        // cleanup
        return function cleanup() {
            clearInterval(timer.current);
        };
    }, [fetchProps]);

    // Browsers throttle and eventually freeze timers in a background tab, so the badge
    // comes back showing a pre-departure count. Refetch on return instead of waiting out
    // the remaining interval.
    usePageVisibility(
        () => {
            if (!init) return;
            fetch(fetchProps.page, fetchProps.params);
            startTimer();
        },
        () => {
            timer.current && clearInterval(timer.current);
        }
    );

    return [start, res, ...rest];
}
